import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { take } from 'rxjs';
import { Contact } from 'src/app/models/contact';
import { CreateContactComponent } from '../create-contact/create-contact.component';
import { SelectContactStoreService } from './select-contact.store.service';
import {
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
  MatAutocomplete
} from '@angular/material/autocomplete';
import { AsyncPipe } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { ContactService } from '../../services/contact.service';
@Component({
  selector: 'app-select-contact',
  templateUrl: './select-contact.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SelectContactStoreService, ContactService],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatIconButton,
    MatIcon,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatAutocomplete,
    MatOption,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    AsyncPipe
  ]
})
export class SelectContactComponent {
  searchResults$ = this.store.searchResults$;
  searchControl = new FormControl<string>('');
  selectedContact$ = this.store.selectedContact$;

  constructor(
    private store: SelectContactStoreService,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: { customerId: number; contact?: Contact }
  ) {
    this.store.search(this.searchControl.valueChanges);
    this.store.setCustomerId(data.customerId);
    if (data.contact) {
      this.store.setSelectedContact(data.contact);
    }
  }

  selectContact($event: MatAutocompleteSelectedEvent) {
    this.store.setSelectedContact($event.option.value);
  }

  openAddDialog() {
    this.matDialog
      .open(CreateContactComponent, {
        data: this.data.customerId
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((contact: Contact | null) =>
        this.store.setSelectedContact(contact)
      );
  }

  clearSelectedContact() {
    this.store.setSelectedContact(null);
  }

  mapItem(event) {
    return '';
  }
}
